import { VacancyBase, ParsedVacancy, VacanciesType } from './types';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { format, parse } from 'date-fns';
import ru from 'date-fns/locale/ru';

const parseVacancy = (item: VacancyBase): Readonly<ParsedVacancy> =>
  Object.freeze({
    id: item!.id || '',
    name: item!.vacancy_name || '',
    salary: parseSalary(item!.salary),
    user_can_create_order: item.user_can_create_order || false,
    main: {
      description: item!.vacancy_desc || '',
      duties: item!.duties || '',
      employmentTypeName: item!.employment_type_name || '',
      beginWork: item!.begin_work || '',
      endWork: item!.end_work || '',
      workPlaceAddress: item!.work_place_address || '',
      placeTypeName: item!.place_type_name || '',
      isAgreement: parseAgreement(item!.is_agreement),
      isOtherCities: parseAgreement(item!.is_other_cities),
      experience: item!.experience || '',
      educationLevelName: item!.education_level_name || '',
      requirements: item!.requirements || '',
      driverLicenseName: item!.driver_license_name || '',
      languages: item!.languages || '',
      competencesName: parseNamesToString(item!.competences_name),
      professionsName: parseNamesToString(item!.professions_name),
      publish_date: parseDateFormat(item!.publish_date),
      video: item!.video || '',
    },
    sidebar: {
      organizationAddress: item!.organization_address || '',
      phoneNumber: parsePhone(item!.phone_number),
      email: item!.email || '',
      site: item!.site || '',
      description: item!.description || '',
      contactPerson: item!.contact_person || '',
      partnerName: item!.partner_name || '',
      partnerLogo: item!.partner_logo || '',
      partnerId: item!.partner_id || '',
      cop_multi_name: item!.cop_multi_name || '',
    },
  });

const parseSalary = (val: string) => {
  return val
    ? `${val.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} руб.`
    : 'Не указана';
};

const parsePhone = (val: string[]) =>
  isArrayNotEmpty(val) ? `<p>${val.join('<br>')}</p>` : '';

const parseAgreement = (val: boolean) => (val ? 'Да' : 'Нет');

const parseNamesToString = (val: Array<string>): string =>
  !isArrayNotEmpty(val) ? '' : val.join(', ');

const parseDateFormat = (date: string) => {
  return date ? format(parse(date), 'DD MMMM YYYY', { locale: ru }) : '';
};

export default parseVacancy;



// WEBPACK FOOTER //
// ./src/services/api/vacancies/utils/parseVacancy.ts